"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _Dropdown = require("../../../../../ui/Dropdown");
var _helpers = require("../../helpers");
var _useFiltersData2 = require("../../useFiltersData");
var _FiltersTriggerButton = require("../FiltersTriggerButton");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FiltersDropdown = function FiltersDropdown(_ref) {
  var countryID = _ref.countryID,
    children = _ref.children,
    initialFilters = _ref.filters,
    offers = _ref.offers,
    title = _ref.title,
    onSubmit = _ref.onSubmit;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var _useFiltersData = (0, _useFiltersData2.useFiltersData)({
      countryID: countryID,
      offers: offers
    }),
    hourRanges = _useFiltersData.hourRanges,
    operators = _useFiltersData.operators,
    rooms = _useFiltersData.rooms;
  var _useState = (0, _react.useState)(initialFilters),
    _useState2 = _slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var isHourRangeFilterEmpty = (0, _helpers.getIsHourRangeFilterEmpty)(filters.inbound) && (0, _helpers.getIsHourRangeFilterEmpty)(filters.outbound);
  var isInitialHourRangeFilterEmpty = (0, _helpers.getIsHourRangeFilterEmpty)(initialFilters.inbound) && (0, _helpers.getIsHourRangeFilterEmpty)(initialFilters.outbound);
  var onBack = (0, _react.useCallback)(function () {
    setFilters(initialFilters);
  }, [initialFilters]);
  return /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownControl, {
    className: _styles.default['filters-dropdown'],
    triggerButton: /*#__PURE__*/_react.default.createElement(_FiltersTriggerButton.FiltersTriggerButton, {
      filters: initialFilters
    })
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownControl.Body, {
    className: _styles.default['filters-dropdown__body'],
    mobileHeaderClassName: _styles.default['filters-dropdown__mobile-header'],
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
      className: _styles.default['filters-dropdown__mobile-title']
    }, title), /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownConsumer, null, function (_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: _styles.default['filters-dropdown__mobile-reset-btn'],
        fontFamily: _Button.FONT_FAMILIES.REGULAR,
        size: _Button.SIZES.SMALL,
        theme: _Button.THEMES.TRANSPARENT,
        onClick: function onClick() {
          close();
          setFilters((0, _helpers.createFilters)());
          onSubmit((0, _helpers.createFilters)());
        }
      }, t('RESET_FILTER_BUTTON'));
    })),
    onBack: onBack
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown__content']
  }, children, /*#__PURE__*/_react.default.createElement("ul", {
    className: _styles.default['filters-dropdown-filters']
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: _styles.default['filters-dropdown-filters-item']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-header']
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: _styles.default['filters-dropdown-filters-item-header__title']
  }, t('FILTER_ROOM_TITLE')), !(0, _helpers.getIsRoomFilterEmpty)(initialFilters.rooms) && !(0, _helpers.getIsRoomFilterEmpty)(filters.rooms) && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default['filters-dropdown__mobile-reset-btn'],
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.SMALL,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: function onClick() {
      setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('rooms', (0, _helpers.createFilters)().rooms)]));
    }
  }, t('RESET_FILTER_BUTTON'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-body']
  }, (0, _ramda.map)(function (room) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filters-dropdown-filters-item-body__button'],
      key: room.id,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsRoomFilterActive)(room.id, filters.rooms) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('rooms', (0, _helpers.toggleRoomFilterValue)(room.id, filters.rooms))]));
      }
    }, room.name);
  }, rooms))), /*#__PURE__*/_react.default.createElement("li", {
    className: _styles.default['filters-dropdown-filters-item']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-header']
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: _styles.default['filters-dropdown-filters-item-header__title']
  }, t('FILTER_OPERATOR_TITLE')), !(0, _helpers.getIsOperatorFilterEmpty)(initialFilters.operators) && !(0, _helpers.getIsOperatorFilterEmpty)(filters.operators) && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default['filters-dropdown__mobile-reset-btn'],
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.SMALL,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: function onClick() {
      setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('operators', (0, _helpers.createFilters)().operators)]));
    }
  }, t('RESET_FILTER_BUTTON'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-body']
  }, (0, _ramda.map)(function (operator) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filters-dropdown-filters-item-body__button'],
      key: operator.id,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsOperatorFilterActive)(operator.id, filters.operators) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('operators', (0, _helpers.toggleOperatorFilterValue)(operator.id, filters.operators))]));
      }
    }, operator.name);
  }, operators))), /*#__PURE__*/_react.default.createElement("li", {
    className: _styles.default['filters-dropdown-filters-item']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-header']
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: _styles.default['filters-dropdown-filters-item-header__title']
  }, t('FILTER_FLIGHT_START')), !isInitialHourRangeFilterEmpty && !isHourRangeFilterEmpty && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default['filters-dropdown__mobile-reset-btn'],
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.SMALL,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: function onClick() {
      var _createFilters = (0, _helpers.createFilters)(),
        inbound = _createFilters.inbound,
        outbound = _createFilters.outbound;
      setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('outbound', outbound), (0, _helpers.createFilter)('inbound', inbound)]));
    }
  }, t('RESET_FILTER_BUTTON'))), /*#__PURE__*/_react.default.createElement("h5", {
    className: _styles.default['filters-dropdown-filters-item__subTitle']
  }, t('FILTER_FLIGHT_DEPARTURE_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-body']
  }, (0, _ramda.map)(function (rangeOption) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filter-hour-range-option'],
      key: rangeOption.key,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsHourRangeFilterActive)(rangeOption.value, filters.outbound) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('outbound', (0, _helpers.toggleHourRangeFilterValue)(rangeOption.value, filters.outbound))]));
      }
    }, rangeOption.content);
  }, hourRanges)), /*#__PURE__*/_react.default.createElement("h5", {
    className: (0, _classnames.default)(_styles.default['filters-dropdown-filters-item__subTitle'], _styles.default['filters-dropdown-filters-item__subTitle--offset-top'])
  }, t('FILTER_FLIGHT_ARRIAVAL_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown-filters-item-body']
  }, (0, _ramda.map)(function (rangeOption) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filter-hour-range-option'],
      key: rangeOption.key,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsHourRangeFilterActive)(rangeOption.value, filters.inbound) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        setFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('inbound', (0, _helpers.toggleHourRangeFilterValue)(rangeOption.value, filters.inbound))]));
      }
    }, rangeOption.content);
  }, hourRanges)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['filters-dropdown__footer']
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownConsumer, null, function (_ref3) {
    var close = _ref3.close;
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: _Button.SIZES.LARGE,
      theme: _Button.THEMES.PURPLE,
      width: _Button.WIDTHS.FLUID,
      onClick: function onClick() {
        onSubmit(filters);
        close();
      }
    }, t('APPLY_FILTERS_BUTTON'));
  })));
};
FiltersDropdown.propTypes = {
  children: _propTypes.default.node.isRequired,
  filters: _propTypes.default.object.isRequired,
  title: _propTypes.default.string.isRequired,
  countryID: _propTypes.default.number.isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = exports.default = FiltersDropdown;